// data-email-validate="true" が付いた入力欄向けの軽量なメールドメイン候補サジェスト。
// 入力ミスが疑われる場合、下に「xxx ではありませんか？修正する場合はこちらをクリック」と表示し、クリックで修正候補を入力可能。
(function () {
  'use strict';

  const commonDomains = [
    // グローバル（フリーメール）
    'gmail.com',
    'yahoo.co.jp',
    'yahoo.com',
    'icloud.com',
    'outlook.jp',
    'outlook.com',
    'hotmail.com',
    'live.com',
    'me.com',
    'mail.com',
    'gmx.com',
    'proton.me',
    'protonmail.com',
    'yandex.com',

    // 日本の主要キャリア
    'docomo.ne.jp',
    'ezweb.ne.jp',
    'au.com',
    'softbank.ne.jp',
    'i.softbank.jp',
    'ymobile.ne.jp',
    'uqmobile.jp',

    // 日本のISP（プロバイダ）
    'nifty.com',
    'nifty.ne.jp',
    'so-net.ne.jp',
    'biglobe.ne.jp',
    'ocn.ne.jp',
    'rakuten.jp',
    'yahoo.ne.jp',
    'ymail.ne.jp'
  ];

  function levenshtein(a, b) {
    const m = a.length;
    const n = b.length;
    if (m === 0) return n;
    if (n === 0) return m;
    const dp = new Array(n + 1);
    for (let j = 0; j <= n; j++) dp[j] = j;
    for (let i = 1; i <= m; i++) {
      let prev = i - 1;
      dp[0] = i;
      for (let j = 1; j <= n; j++) {
        const temp = dp[j];
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        dp[j] = Math.min(
          dp[j] + 1,       // deletion
          dp[j - 1] + 1,   // insertion
          prev + cost      // substitution
        );
        prev = temp;
      }
    }
    return dp[n];
  }

  function closestDomain(inputDomain) {
    let best = null;
    let bestDist = Infinity;
    for (const d of commonDomains) {
      const dist = levenshtein(inputDomain, d);
      if (dist < bestDist) {
        best = d;
        bestDist = dist;
      }
    }
    // Only suggest when reasonably close (1 or 2 edits)
    return bestDist <= 2 ? best : null;
  }

  function buildSuggestionElement(suggestedDomain, template, onApply) {
    const wrap = document.createElement('div');
    wrap.className = 'js-email-suggestion mt-1 fs-sm';
    const small = document.createElement('small');
    small.className = 'text-muted text-start';
    const link = document.createElement('a');
    link.href = '#';
    link.textContent = template.replace('%{domain}', suggestedDomain);
    link.addEventListener('click', function (e) {
      e.preventDefault();
      onApply();
    });
    small.appendChild(link);
    wrap.appendChild(small);
    return wrap;
  }

  function removeSuggestion(input) {
    const existing = input.parentElement && input.parentElement.querySelector('.js-email-suggestion');
    if (existing) existing.remove();
  }

  function showSuggestion(input, suggestedDomain) {
    removeSuggestion(input);
    const template = input.dataset.emailSuggestText;
    const el = buildSuggestionElement(suggestedDomain, template, function () {
      const value = (input.value || '').trim();
      const at = value.indexOf('@');
      if (at === -1) return;
      const replaced = value.slice(0, at + 1) + suggestedDomain;
      input.value = replaced;
      removeSuggestion(input);
      // Re-trigger validation if present
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('blur', { bubbles: true }));
      input.focus();
    });
    input.insertAdjacentElement('afterend', el);
  }

  function computeSuggestion(value) {
    const trimmed = (value || '').trim();
    const at = trimmed.indexOf('@');
    if (at === -1) return null;
    const domain = trimmed.slice(at + 1).toLowerCase();
    if (!domain) return null;
    // If already an exact common domain, no suggestion
    if (commonDomains.includes(domain)) return null;
    // If domain lacks a dot, try direct completion for popular domains
    if (!domain.includes('.')) {
      if (domain === 'gmail') return 'gmail.com';
      if (domain === 'yahoo') return 'yahoo.co.jp';
    }
    return closestDomain(domain);
  }

  function attach(input) {
    if (input.dataset.emailSuggestBound === '1') return;
    input.dataset.emailSuggestBound = '1';

    const handler = () => {
      const suggestion = computeSuggestion(input.value);
      if (suggestion) {
        showSuggestion(input, suggestion);
      } else {
        removeSuggestion(input);
      }
    };
    input.addEventListener('blur', handler);
    input.addEventListener('input', function () {
      removeSuggestion(input);
    });
  }

  function init() {
    document.querySelectorAll('[data-email-validate="true"]').forEach(attach);
  }

  document.addEventListener('turbolinks:load', init);
})();


